import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Firestore, collection, addDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent {

  isModal = false;
  mensaje: string = '';

  constructor(private firestore: Firestore) {}

  openModal() {
    this.isModal = true;
  }

  closeModal() {
    this.isModal = false;
  }

  async guardarMensaje() {

    if (!this.mensaje || this.mensaje.trim() === '') {
      alert('Escribí un mensaje');
      return;
    }

    try {
      const mensajesRef = collection(this.firestore, 'mensajes');

      await addDoc(mensajesRef, {
        mensaje: this.mensaje,
        fecha: new Date()
      });

      alert('Mensaje enviado 💌');

      this.mensaje = '';
      this.isModal = false;

    } catch (error) {
      console.error(error);
      alert('Error al enviar ❌');
    }
  }
}